// extracted by mini-css-extract-plugin
export default {"forgotPassword":"ForgotPasswordPage_forgotPassword__PzANW","container":"ForgotPasswordPage_container__V9Gai","wrapper":"ForgotPasswordPage_wrapper__RCGdw"};